var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,10v55.4C10,80.6,22.4,93,37.6,93h27.6c15.2,0,27.6-12.4,27.6-27.6V10L72.2,23.9h-6.9H30.7L10,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.6,30.7v-6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,30.7v-6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,37.6V23.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,58.4c0,7.7-6.2,13.9-13.9,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,72.2c-7.7,0-13.9-6.2-13.9-13.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.4,58.4H44.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1,51.5H93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.1,65.4H93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,51.5h6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,65.4h6.9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.9,49.2c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7S41.4,49.2,42.9,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6,49.2c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7c-1.5,0-2.7,1.2-2.7,2.7S60.1,49.2,61.6,49.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeline);
export default __webpack_public_path__ + "static/media/feline.e0490b39d4d6784eb372ee9da64cd26b.svg";
export { ForwardRef as ReactComponent };